import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AdminAppBar from "./AdminAppBar";
import * as xlsx from "xlsx";
import axios from "axios";
import LeadUploadService from "../Services/LeadUploadService";
import leadSourceService from "../Services/LeadSourceService";
import InterestedTagService from "../Services/InterestedTagService";
import propertyService from "../Services/PropertyService";
import teamService from "../Services/TeamService";
import { bulkFolderPath, getIcons } from "../Constant/Constant";
import { interestLevel, leadStatusMap } from "../../Enum";
import { showErrorToast, showInfoToast, showSuccessToast } from "../Constant/Notification";
import AppBar from "../leadComponent/AppBar";
import userServices from "../Services/UserService";
import LocationService from "../Services/LocationService";
import BulkCompletedModel from "./BulkCompletedModel";
import DuplicateLeadDownload from "./DuplicateLeadDownload";
import LeadLimitModel from "./LeadLimitModel";
import ValidationModal from "../SetupComponents/PropertyComponent/ValidationModal";
import SpinWheelService from "../Services/SpinWheelService";
import Loader from "../Constant/Loader";

const AdminBulkUpload = () => {
  const navigate = useNavigate();
  const icon = getIcons();

  const [fileImageUrl,setFileImageUrl]=useState("")


  const userObj = JSON.parse(localStorage.getItem("userData"));
  const userRole = userObj?.user?.role;
  let bodTeamId;
  if (userRole === "BOD") {
    bodTeamId = userObj?.teamId[0].id;
  }

  const handleUpload =  async () => {
    if (!validateForm()) return;

    let tags = [];
    interestTags.forEach((item) => {
      tags.push(item.value);
    });

    let locationTags = [];
    interestLocationTags.forEach((item) => {
      locationTags.push(item.value);
    });

    let obj;
    if (userRole === "Admin" || userRole === "CMO" || userRole === "Lead Uploader") {
      obj = {

            assignedTeam: selectedTeam,
        assignedUser: isAssignedUser ? selectedUser : "",
        createdBy: userObj.user.uid,
        fieldWorker: selectedLeadGivenBy,
        interestTags: tags,
        interestedLocations: locationTags,
        leadQuality: selectedLevel?.value ? selectedLevel.value : "",
        fileUrl :fileImageUrl,
        leadSource: selectedLeadSourceId,
        modifiedBy: userObj.user.uid,
      //  leads: inputJson,
        status: selectedStatus,
      };
    } else if (userRole === "BOD") {
      obj = {
        assignedTeam: bodTeamId,
        assignedUser: selectedUser || "",
        createdBy: userObj.user.uid,
        fieldWorker: selectedLeadGivenBy,
        interestTags: tags,
        leadQuality: selectedLevel?.value ? selectedLevel.value : "",
        interestedLocations: locationTags,
        leadSource: selectedLeadSourceId,
        modifiedBy: userObj.user.uid,
        fileUrl :fileImageUrl,
       // leads: inputJson,
        status: selectedStatus,
      };
    }

    setLoading(true);

try{
  const response = await LeadUploadService.createBulkUploadExcel(obj)
  console.log(response)
  
        
        // setLeadStatus(response.data);
        // setSuccess(true);
        showSuccessToast("Once the lead is uploaded, a confirmation will be sent to your email.")
        setSelectedFile(null);
        setSelectedLeadSource("");
        setFileImageUrl(null);

        setTimeout(()=>{
          navigate(-1)
        },2000)
  
}catch(error)
{     showErrorToast(error.response.data.message);

  console.log(error)
}finally{
  setLoading(false);
}
  
  };

  const handleBack = () => {
    navigate(-1);
  };
  const [interestTags, setInterestTags] = useState([]);
  const [options, setOptions] = useState([]);
  const [success, setSuccess] = useState(false);
  const [leadStatus, setLeadStatus] = useState([]);
  const [menuOpen, setMenuOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [inputJson, setInputJson] = useState(null);
  const [leadSources, setLeadSources] = useState([]);
  const [properties, setProperties] = useState([]);
  const [teams, setTeams] = useState([]);
  const [isAssignedTeam, setIsAssignedTeam] = useState(false);
  const [isAssignedUser, setIsAssignedUser] = useState(false);
  const [budget, setBudget] = useState();
  const [selectedLeadSourceId, setSelectedLeadSourceId] = useState("");
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");
  const [leadGivenUsers, setLeadGivenUsers] = useState([]);
  const [selectedLeadGivenBy, setSelectedLeadGivenBy] = useState();
  const [fieldWorkers, setFieldWorkers] = useState([]);
  const [interestLocationTags, setInterestedLocationTags] = useState([]);
  const [optionLocation, setOptionLocation] = useState([]);

  const [interestedTags, setInterestedTags] = useState([]);

  const [selectedTeam, setSelectedTeam] = useState("");
  const [selectedLeadSource, setSelectedLeadSource] = useState("");
  const [selectedProperty, setSelectedProperty] = useState("");
  const [duplicates, setDuplicates] = useState([]);

  const [selectedStatus, setSelectedStatus] = useState(leadStatusMap["Fresh"]);

  const [selectedFieldWorker, setSelectedFieldWorker] = useState("");
  const [fieldWorkerError, setFieldWorkerError] = useState(false);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const [selectedLevel, setSelectedLevel] = useState();
  const [validationErrors, setValidationErrors] = useState([]);
const [showValidationModal, setShowValidationModal] = useState(false);


  const handleSelectChange = (selectedOption) => {
    setSelectedLevel(selectedOption);
  };

  const validateForm = () => {
    const newErrors = {};

    if (!selectedLeadSource) {
      newErrors.leadSource = "Lead Source is required";
      showErrorToast("Lead Source is required");
    } else if (!selectedFile) {
      newErrors.selectedFile = "Selected file is required";
      toast.error("Please select a file", {
        position: "top-center",
        theme: "light",
        className: "absolute top-20",
      });
    } else if (userRole !== "BOD" && !selectedTeam)
      {
      newErrors.teams = "Team is required";
      showErrorToast("Team is required");
    } else if (!selectedStatus) {
      newErrors.status = "Status is required";
      showErrorToast("Status is required");
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (selectedOptions) => {
    setInterestTags(selectedOptions);
  };
  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    const validFileTypes = [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "text/csv",
    ];
  
    if (file && !validFileTypes.includes(file.type)) {
      alert("Invalid file type. Only .xlsx  files are allowed.");
      setSelectedFile(null);
      return;
    }
  
    setSelectedFile(file);
  
    if (file) {
      const reader = new FileReader();
      reader.onload = async (e) => {
        const data = e.target.result;
        const workbook = xlsx.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const json = xlsx.utils.sheet_to_json(worksheet);

        if (json.length > 50000) {
          showInfoToast("The file contains more than 50,000 rows. Please upload a smaller file.");
          setSelectedFile(null);
          e.target.value = "";
          return;
        }
  
        const phoneNumbers = new Set();
        const duplicateRows = [];
        const validationErrors = [];
        const cleanData = [];
  
        json.forEach((item, index) => {
          const row = index + 2;
          const rawPhone = String(item["Phone Number"] || "").trim();
          const name = String(item["Name"] || "").toLocaleLowerCase();
         
  
          if (!/^\d{10}$/.test(rawPhone)) {
            validationErrors.push({
              row,
              field: "Phone Number",
              message: "Invalid phone number. Only numbers between 10 digits allowed.",
            });
            return;
          }
  
          if (phoneNumbers.has(rawPhone)) {
            duplicateRows.push({
              rowNumber: row,
              phoneNumber: rawPhone,
              name,
            });
            return;
          }
  
          phoneNumbers.add(rawPhone);
  
          cleanData.push({
            name: name,
            phoneNumber: rawPhone,
            countryCode: String(item["Country Code"] || "").toLowerCase(),
            emailId: String(item["Email ID"] || ""),
          });
          
        });
  
      
        if (validationErrors.length > 0) {
          setValidationErrors(validationErrors);
          setShowValidationModal(true);
          setSelectedFile(null);
          e.target.value = "";
          return;
        }
  
       
        if (duplicateRows.length > 0) {
          setDuplicates(duplicateRows);
          setIsModalOpen2(true);
          setSelectedFile(null);
          e.target.value = "";
          return;
        }
  
        
        setInputJson(cleanData);
        try {
          setLoading(true)
          const formData = new FormData();
          formData.append("file", file);
          const response = await SpinWheelService.createBannerImageTemplate(formData, bulkFolderPath);
          console.log("Upload successful:", response.data);
          setFileImageUrl(response.data?.imageUrl)
        } catch (error) {
          console.error("API upload error:", error);
        }finally{
          setLoading(false)
        }
      };
  
      reader.readAsArrayBuffer(file);
    }
  };
  
  

  const handleLocationChange = (event) => {
    setInterestedLocationTags(event);
  };
  const handleBudgetChange = (e) => {
    setBudget(e.target.value);
  };

  useEffect(() => {
    (async () => {
      try {
        const response = await leadSourceService.fetchLeadSources();
        const data = response.data;
        console.log(data);
        setLeadSources(data || []);
      } catch (error) {
        console.error("Error fetching leadSources:", error);
        // Handle error if needed
      }

      try {
        const response = await InterestedTagService.fetchInterestedTag();
        const responseLocation = await LocationService.fetchLocation();
        const data = response.data;
        const dataLocation = responseLocation.data;
        const formattedLocations = Object.entries(dataLocation).map(
          ([name, id]) => ({
            value: id,
            label: name,
          })
        );

        setOptionLocation(formattedLocations);
        console.log("Interest Location Data:", formattedLocations);
        //   console.log(data)
        setInterestedTags(data);
        let optionsArray = [];
        data.forEach((item) => {
          optionsArray.push({ value: item.id, label: item.name });
        });
        setOptions(optionsArray);
      } catch (error) {
        console.error("Error fetching interested tags:", error);
        // Handle error if needed
      }

      try {
        const response = await teamService.fetchTeams();
        const data = response.data;
        setTeams(data);
      } catch (error) {
        console.error("Error fetching teams:", error);
        // Handle error if needed
      }
      try {
        const response = await userServices.fetchLeadGivenByUsers();
        const data = response.data;

        setLeadGivenUsers(data);
      } catch (error) {
        console.log(error.message);
      }
    })();
  }, []);
  console.log(leadGivenUsers);
  const status = [
    "Fresh",
    "Follow-up",
    "Dealing",
    "Registered Client",
    "Deal Lost",
    "Unanswered",
    "Not Interested",
    "Retry Suitable",
  ];

  const handleLeadAssignChange = (type) => {
    if (type === "Assign to team") {
      setIsAssignedTeam(true);
      setIsAssignedUser(false);
    } else if (type === "Assign to user") {
      setIsAssignedTeam(true);
      setIsAssignedUser(true);
    }
  };
  const handleTeamChange = async (e) => {
    setSelectedTeam(e);
    setErrors((prevErrors) => ({ ...prevErrors, teams: "" }));
  };

  useEffect(() => {
    const fetchUsersByTeam = async () => {
      let teamIdToFetch = userRole === "BOD" ? bodTeamId : selectedTeam;

      if (teamIdToFetch) {
        try {
          const response = await teamService.getTeamData(teamIdToFetch); // Pass selectedTeam
          const data = response.data;
          console.log(data);
          const combinedUsers = [
            ...(Array.isArray(data.BOD) && data.BOD.length > 0 
                ? data.BOD.map(bod => ({ name: bod.name, id: bod.id })) 
                : []),
            ...(data.MD && data.MD.name !== null && data.MD.id !== null 
                ? [{ name: data.MD.name, id: data.MD.id }] 
                : []),
            ...(Array.isArray(data.members) && data.members.length > 0 
                ? data.members.map(member => ({ name: member.name, id: member.id })) 
                : [])
        ];
        
  
        const finalUsers = combinedUsers.length > 0 ? combinedUsers : [];
        
        console.log("Final Users:", finalUsers);
        
          setUsers(finalUsers);
          console.log(users);
        } catch (error) {
          console.error("Error fetching users by team:", error);
          showErrorToast("Error fetching users");
        }
      }
    };

    fetchUsersByTeam();
  }, [selectedTeam, isAssignedUser]);

  const handleLeadSourceChange = (e) => {
    setSelectedLeadSource(e);
    setSelectedLeadSourceId(e.value);
    setErrors((prevErrors) => ({ ...prevErrors, leadSources: "" }));
  };

  const handlePropertyChange = (e) => {
    setSelectedProperty(e);
  };

  const handleStatusChange = (e) => {
    setSelectedStatus(leadStatusMap[e]);
    setErrors((prevErrors) => ({ ...prevErrors, status: "" }));
  };

  // const handleFieldWorkerChange = (e) => {
  //   setSelectedFieldWorker(e);
  // };

  const handleDownloadTemplate = () => {
    const link = document.createElement("a");
    link.href = "/Sample lead upload Template.xlsx";
    link.setAttribute("download", "sample-template for bulk upload.xlsx");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpen2, setIsModalOpen2] = useState(false);
  const [isModalOpen3, setIsModalOpen3] = useState(false);
  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  // Function to close the image modal
  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "transparent",
      border: "none",
      boxShadow: "none",
    }),
  };
  const getBackgroundClass = (label) => {
    switch (label.toLowerCase()) {
      case "gold":
        return "bg-gradient-to-b from-[#FFB947] to-[#ECCD90] bg-clip-text text-transparent";
      case "silver":
        return "bg-gradient-to-b from-[#B6B6B6] to-[#E8E8E8] bg-clip-text text-transparent";
      case "bronze":
        return "bg-gradient-to-b from-[#BA7E5E] via-[#FF9F6B] to-[#411904] bg-clip-text text-transparent";
      case "diamond":
        return "bg-gradient-to-b from-[#0563FF] to-[#4085F8] bg-clip-text text-transparent";
      default:
        return "text-black";
    }
  };

  return (
    <>
      {userRole === "Lead Uploader" ? <AppBar /> : <AdminAppBar />}


      {loading && (
        <Loader/>
      )}

      <ToastContainer />

      <div className=" bg-appGrayBackground px-6 flex flex-col gap-5 pb-5 mt-20 pt-4 ">
        <div className="flex justify-between gap-5 ">
          <div className="flex gap-6">
            <svg
              onClick={handleBack}
              className="cursor-pointer "
              width="20"
              height="34"
              viewBox="0 0 22 38"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.23223 17.2322C0.255922 18.2085 0.255922 19.7915 1.23223 20.7678L17.1421 36.6777C18.1184 37.654 19.7014 37.654 20.6777 36.6777C21.654 35.7014 21.654 34.1184 20.6777 33.1421L6.53553 19L20.6777 4.85786C21.654 3.88155 21.654 2.29864 20.6777 1.32233C19.7014 0.34602 18.1184 0.34602 17.1421 1.32233L1.23223 17.2322ZM5 16.5L3 16.5L3 21.5L5 21.5L5 16.5Z"
                fill="#399E79"
              />
            </svg>
            <div className="font-semibold md:mx-0  lg:mx-0 md:text-2xl lg:text-4xl">
              Bulk Upload
            </div>
          </div>

          <div className="">
            <button
              onClick={handleUpload}
              className="bg-customGreen text-white md:w-28  md:h-9 lg:w-48 lg:h-11 rounded-md md:text-xl
          lg:text-2xl font-medium"
              disabled={loading}
            >
              {" Upload"}
            
            </button>
          </div>
        </div>

        <form className="bg-white shadow-md rounded mx-12 p-5">
          <div className="mb-8 flex items-center">
            <label
              className="w-1/4 text-black text-2xl xl:text-xl  font-bold"
              htmlFor="lead-source"
            >
              Lead Source <span className="text-red-600">*</span>
            </label>
            <div className="flex w-3/4">
              <Select
                options={leadSources.map((source) => ({
                  value: source.id,
                  label: source.name,
                }))}
                onChange={handleLeadSourceChange}
                value={selectedLeadSource}
                placeholder="Select Lead Source"
                isClearable
                isSearchable
                className="w-full focus:outline-none focus:shadow-outline"
              />
            </div>
          </div>
          <div className="mb-8 flex items-center">
            <label
              className="w-1/4 text-black text-2xl xl:text-xl  font-bold"
              htmlFor="interest-tag"
            >
              Interest Tag
            </label>
            <div className="flex w-3/4  ">
              <Select
                className={`w-full py-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                  errors.interestTags && "border-red-500"
                }`}
                // className="w-full py-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                value={interestTags}
                onChange={handleChange}
                options={options}
                isMulti
                //   menuPlacement="top"
                onMenuOpen={() => setMenuOpen(true)}
                onMenuClose={() => setMenuOpen(false)}
                styles={{
                  control: (provided) => ({
                    ...provided,
                    minHeight: "100px",
                  }),
                  multiValue: (provided) => ({
                    ...provided,
                    backgroundColor: "#339E79", // Change background color of the chip
                    borderRadius: "4px",
                    padding: "2px 4px",
                    color: "white", // Change text color of the chip
                  }),
                  multiValueLabel: (provided) => ({
                    ...provided,
                    color: "white",
                    // Change text color of the label inside the chip
                  }),
                }}
                placeholder={errors.interestTags || "Type to search eg :"}
              />
            </div>
          </div>

          <div className="mb-4 flex  items-center">
            <label
              className="w-1/4 text-black  text-2xl xl:text-xl font-bold"
              htmlFor="interest-tag"
            >
              Interest locations
            </label>
            <div className="flex w-3/4   ">
              <Select
                className={`w-full py-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                  errors.interestTags && "border-red-500"
                }`}
                value={interestLocationTags}
                onChange={handleLocationChange}
                options={optionLocation}
                isMulti
                menuPlacement="top"
                onMenuOpen={() => setMenuOpen(true)}
                onMenuClose={() => setMenuOpen(false)}
                styles={{
                  control: (provided) => ({
                    ...provided,
                    minHeight: "100px",
                  }),
                  multiValue: (provided) => ({
                    ...provided,
                    backgroundColor: "#339E79", // Change background color of the chip
                    borderRadius: "4px",
                    padding: "2px 4px",
                    color: "white", // Change text color of the chip
                  }),
                  multiValueLabel: (provided) => ({
                    ...provided,
                    color: "white", // Change text color of the label inside the chip
                  }),
                }}
                placeholder={errors.interestTags || "Type to search eg :"}
              />
            </div>
          </div>

          <div className="mb-8 flex items-center">
            <label className="w-1/4 text-black text-2xl xl:text-xl font-bold">
              Lead Quality <span className="text-red-600">*</span>
            </label>
            <div className="w-3/4 flex items-center border rounded shadow px-2 ">
              <Select
                className="w-full bg-transparent text-gray-700 focus:outline-none"
                value={selectedLevel}
                placeholder="Select Lead Quality"
                onChange={handleSelectChange}
                options={interestLevel}
                formatOptionLabel={(e) => (
                  <div className="flex items-center">
                    <img src={e.image} alt={e.label} className="w-6 h-6 mr-2" />
                    <span
                      className={`${getBackgroundClass(e.label)} font-bold `}
                    >
                      {e.label}
                    </span>
                  </div>
                )}
                styles={customStyles}
              />
            </div>
          </div>
          <div className=" flex w-full justify-between">
            <div className="mb-8 flex justify-between w-full gap-5">
              <label
                className="w-1/4 text-black text-2xl xl:text-xl  font-bold"
                htmlFor="file-upload"
              >
                Attach File <span className="text-red-600">*</span>
              </label>
              <label className="w-full ml-24 ">
                <div className="relative border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline cursor-pointer">
                  <span className="absolute inset-y-0 right-3 flex items-center pl-3">
                    <svg
                      className=" md:w-6"
                      width="30"
                      height="30"
                      viewBox="0 0 135 135"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0 0H134.449V134.449H0V0Z"
                        fill="white"
                        fill-opacity="0.01"
                      />
                      <path
                        d="M67.2231 123.245H22.4067V11.2036H112.04V67.2242"
                        stroke="#399E79"
                        stroke-width="7.31632"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M99.4365 123.245V86.8313"
                        stroke="#399E79"
                        stroke-width="7.31632"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M86.8325 96.6349L91.0341 92.4334L99.4371 84.0303L107.84 92.4334L112.042 96.6349"
                        stroke="#399E79"
                        stroke-width="7.31632"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M44.8152 44.8159H89.6316"
                        stroke="#399E79"
                        stroke-width="7.31632"
                        stroke-linecap="round"
                      />
                      <path
                        d="M44.8152 67.2241H67.2234"
                        stroke="#399E79"
                        stroke-width="7.31632"
                        stroke-linecap="round"
                      />
                    </svg>
                  </span>
                  <span className="pl-0 pr-3 py-1">
                    {selectedFile
                      ? selectedFile.name
                      : "Click here to select a file from your computer"}
                  </span>
                  <input
                    id="file-upload"
                    className="absolute inset-0 w-full  opacity-0 cursor-pointer"
                    type="file"
                    onChange={handleFileChange}
                  />
                </div>
              </label>

              <div className="flex gap-5 ">
                <div
                  className="flex flex-col items-center cursor-pointer"
                  onClick={handleOpenModal}
                >
                  <img src={icon.infoIcon} alt="" className="w-5" />
                  <div>Instruction</div>
                </div>

                <div
                  className="flex flex-col items-center cursor-pointer"
                  onClick={handleDownloadTemplate}
                >
                  <img src={icon.downloadIcon} alt="" className="w-5" />
                  <div>Template</div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex items-center mb-4">
            <div className="w-1/4"></div>
            {userRole !== "BOD" && (
              <div className="3/4 flex gap-40">
                <label htmlFor="" className="flex gap-2">
                  <input
                    type="radio"
                    value="Assign to team"
                    id="assign-team"
                    className="w-4"
                    checked={isAssignedTeam && !isAssignedUser}
                    onChange={() => handleLeadAssignChange("Assign to team")}
                  />
                  <span>
                    Assign to team <span className="text-red-600">*</span>
                  </span>
                </label>

                <label htmlFor="" className="flex gap-2">
                  <input
                    type="radio"
                    value="Assign to user"
                    id="assign-user"
                    className="w-4"
                    checked={isAssignedUser}
                    onChange={() => handleLeadAssignChange("Assign to user")}
                  />
                  <span>
                    Assign to user <span className="text-red-600">*</span>
                  </span>
                </label>
              </div>
            )}
          </div>

          {isAssignedTeam && userRole !== "BOD" && (
            <div className="mb-8 flex items-center">
              <label className="w-1/4 text-black text-2xl xl:text-xl font-bold">
                Assign to team <span className="text-red-600">*</span>
              </label>
              <div className="flex w-3/4 relative">
                <select
                  className={`appearance-none w-full shadow border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                    errors.teams && "border-red-500"
                  }`}
                  onChange={(e) => handleTeamChange(e.target.value)}
                >
                  <option value="">Select Team</option>
                  {teams.map((item, index) => (
                    <option key={index} value={item.teamId}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          )}

          {(isAssignedUser || userRole === "BOD") && (
            <div className="mb-8 flex items-center">
              <label className="w-1/4 text-black text-2xl xl:text-xl font-bold">
                Assign to user <span className="text-red-600">*</span>
              </label>
              <div className="flex w-3/4 relative">
                <select
                  className={`appearance-none w-full shadow border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                    errors.teams && "border-red-500"
                  }`}
                  onChange={(e) => setSelectedUser(e.target.value)}
                >
                  <option value="">Select User</option>
                  {users.map((item, index) => (
                    <option key={index} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          )}
          {/* <div className="mb-8 flex items-center">
            <label
              className="w-1/4 text-black text-2xl xl:text-xl font-bold"
              htmlFor="lead-source"
            >
              Status <span className="text-red-600">*</span>
            </label>
            <div className="flex w-3/4 relative">
              <select
                className={`appearance-none w-full shadow border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                  errors.status && "border-red-500"
                }`}
                // className="appearance-none w-full shadow border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="lead-source"
                name="lead-source"
                onChange={(e) => handleStatusChange(e.target.value)}
              >
                {status.map((item, index) => {
                  return (
                    <option key={index} value={item}>
                      {item}
                    </option>
                  );
                })}
              </select>
              <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                <svg
                  width="18"
                  height="12"
                  viewBox="0 0 24 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.9393 13.0607C11.5251 13.6464 12.4749 13.6464 13.0607 13.0607L22.6066 3.51472C23.1924 2.92893 23.1924 1.97919 22.6066 1.3934C22.0208 0.807611 21.0711 0.807611 20.4853 1.3934L12 9.87868L3.51472 1.3934C2.92893 0.807611 1.97919 0.807611 1.3934 1.3934C0.807611 1.97919 0.807611 2.92893 1.3934 3.51472L10.9393 13.0607ZM10.5 10V12H13.5V10H10.5Z"
                    fill="#399E79"
                  />
                </svg>
              </div>
            </div>
          </div> */}

          <div className="mb-8 flex items-center">
            <label
              className="w-1/4 text-black text-2xl xl:text-xl font-bold"
              htmlFor="lead-source"
            >
              Lead Given By
            </label>
            <div className="flex w-3/4 relative">
              <select
                className="appearance-none w-full shadow border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="lead-source"
                name="lead-source"
                onChange={(e) => setSelectedLeadGivenBy(e.target.value)}
              >
                {/* {fieldWorkerError ?(
                  <option value="">Select Field worker</option>

                  ):(
                  <option value="">Select Field worker</option>

                  {Array.isArray(fieldWorkers) && fieldWorkers.map((item, index) => {
                    return (
                      <option key={index} value={item.uid}>
                        {item.name}
                      </option>
                    )

                  })})} */}
                {!leadGivenUsers ? (
                  <option value="">No more field workers</option>
                ) : (
                  <>
                    <option value="">Select Lead Given By</option>
                    {Array.isArray(leadGivenUsers) &&
                      leadGivenUsers.map((item, index) => {
                        return (
                          <option key={index} value={item.uid}>
                            {item.name}
                          </option>
                        );
                      })}
                  </>
                )}
              </select>
              <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                <svg
                  width="18"
                  height="12"
                  viewBox="0 0 24 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.9393 13.0607C11.5251 13.6464 12.4749 13.6464 13.0607 13.0607L22.6066 3.51472C23.1924 2.92893 23.1924 1.97919 22.6066 1.3934C22.0208 0.807611 21.0711 0.807611 20.4853 1.3934L12 9.87868L3.51472 1.3934C2.92893 0.807611 1.97919 0.807611 1.3934 1.3934C0.807611 1.97919 0.807611 2.92893 1.3934 3.51472L10.9393 13.0607ZM10.5 10V12H13.5V10H10.5Z"
                    fill="#399E79"
                  />
                </svg>
              </div>
            </div>
          </div>
          {isModalOpen && (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
              <div className="bg-white rounded-lg p-4 md:w-1/2 w-full relative">
                <button
                  onClick={handleCloseModal}
                  className="absolute top-2 right-4 text-black font-bold text-xl"
                >
                  &times;
                </button>
                <h2 className="text-2xl font-semibold mb-4">
                  Excel Template Reference
                </h2>
                <img
                  src={icon.excelImage}
                  alt="Excel Template Reference"
                  className="w-full h-auto"
                />
              </div>
            </div>
          )}
        </form>
      </div>
      <DuplicateLeadDownload
        isOpen={isModalOpen2}
        duplicateLeads={duplicates}
        onClose={() => setIsModalOpen2(false)}
      />
      <BulkCompletedModel
        isOpen={success}
        onClose={() => setSuccess(false)}
        data={leadStatus}
        handleBack={handleBack}
      />
      <ValidationModal
  show={showValidationModal}
  onClose={() => setShowValidationModal(false)}
  errors={validationErrors}
/>

      <LeadLimitModel
        isOpen={isModalOpen3}
        onClose={() => setIsModalOpen3(false)}
      />
    </>
  );
};

export default AdminBulkUpload;

// import React, { useEffect, useState } from "react";
// import Select from "react-select";
// import { useNavigate } from "react-router-dom";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import AdminAppBar from "./AdminAppBar";
// import * as xlsx from "xlsx";
// import axios from "axios";
// import LeadUploadService from "../Services/LeadUploadService";
// import leadSourceService from "../Services/LeadSourceService";
// import InterestedTagService from "../Services/InterestedTagService";
// import propertyService from "../Services/PropertyService";
// import teamService from "../Services/TeamService";
// import { getIcons } from "../Constant/Constant";
// import { leadStatusMap } from "../../Enum";
// import { showErrorToast } from "../Constant/Notification";
// import AppBar from "../leadComponent/AppBar";

// const AdminBulkUpload = () => {
//   const navigate = useNavigate();
//   const icon = getIcons();

//   const userObj = JSON.parse(localStorage.getItem("userData"));
//   const userRole = userObj?.user?.role;

//   const handleBack = () => {
//     if (userRole === "Admin") {
//       navigate("/admin/lead-upload");
//     } else if (userRole === "CMO") {
//       navigate("/cmo/lead-upload");
//     }else if(userRole === "Lead Uploader"){
//       navigate("/lead-uploader")
//     }
//   };
//   const [interestTags, setInterestTags] = useState([]);
//   const [options, setOptions] = useState([]);
//   const [menuOpen, setMenuOpen] = useState(false);
//   const [selectedFile, setSelectedFile] = useState(null);
//   const [inputJson, setInputJson] = useState(null);
//   const [leadSources, setLeadSources] = useState([]);
//   const [properties, setProperties] = useState([]);
//   const [teams, setTeams] = useState([]);

//   const [budget, setBudget] = useState();

//   const [fieldWorkers, setFieldWorkers] = useState([]);

//   const [interestedTags, setInterestedTags] = useState([]);

//   const [selectedTeam, setSelectedTeam] = useState("");
//   const [selectedLeadSource, setSelectedLeadSource] = useState("");
//   const [selectedProperty, setSelectedProperty] = useState("");
// const [selectedLeadSourceId, setSelectedLeadSourceId]= useState("")
//   const [selectedStatus, setSelectedStatus] = useState(leadStatusMap["Fresh"]);

//   const [selectedFieldWorker, setSelectedFieldWorker] = useState("");
//   const [fieldWorkerError, setFieldWorkerError] = useState(false);
//   const [errors, setErrors] = useState({});
//   const [loading, setLoading] = useState(false);

//   const validateForm = () => {
//     const newErrors = {};
//     if (!selectedTeam) newErrors.teams = "Team is required";
//     if (!selectedLeadSource) {
//       newErrors.leadSources = "Lead Source is required";
//     }
//     if (interestTags.length === 0)
//       newErrors.interestTags = "Interested Tag is required";
//     if (!selectedStatus) newErrors.status = "Status is required";
//     if (!selectedFile) {
//       newErrors.selectedFile = "Selected file is required";
//       toast.error("Please select a file", {
//         position: "top-center",
//         theme: "light",
//         className: "absolute top-20",
//       });
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };
//   const handleChange = (selectedOptions) => {
//     setInterestTags(selectedOptions);
//   };
//   const handleFileChange = (e) => {
//     const file = e.target.files[0];
//   const validFileTypes = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'text/csv'];

//   if (file && !validFileTypes.includes(file.type)) {
//     showErrorToast('Invalid file type. Only .xlsx and .csv files are allowed.');
//     setSelectedFile(null);
//     return;
//   }

//   setSelectedFile(file);

//   // if (file) {
//   //     const reader = new FileReader();
//   //     reader.onload = (e) => {
//   //       const data = e.target.result;
//   //       const workbook = xlsx.read(data, { type: "array" });
//   //       const sheetName = workbook.SheetNames[0];
//   //       const worksheet = workbook.Sheets[sheetName];
//   //       const json = xlsx.utils.sheet_to_json(worksheet);

//   //       let inputJson = [];
//   //       json.forEach((item) => {
//   //         inputJson.push({
//   //           name: item["Name"],
//   //           phoneNumber: item["Phone Number"],
//   //           countryCode: item["Country Code"],
//   //           emailId: item["Email ID"],
//   //         });
//   //       });
//   //       // console.log(inputJson);
//   //       setInputJson(inputJson);
//   //     };
//   //     reader.readAsArrayBuffer(e.target.files[0]);
//   //   }
//   };

//   const handleBudgetChange = (e) => {
//     setBudget(e.target.value);
//   };

//   useEffect(() => {
//     (async () => {
//       try {
//         const response = await leadSourceService.fetchLeadSources();
//         const data = response.data;
//         console.log(data);
//         setLeadSources(data);
//       } catch (error) {
//         console.error("Error fetching leadSources:", error);
//         // Handle error if needed
//       }

//       try {
//         const response = await InterestedTagService.fetchInterestedTag();
//         const data = response.data;
//         //   console.log(data)
//         setInterestedTags(data);
//         let optionsArray = [];
//         data.forEach((item) => {
//           optionsArray.push({ value: item.id, label: item.name });
//         });
//         setOptions(optionsArray);
//       } catch (error) {
//         console.error("Error fetching interested tags:", error);
//         // Handle error if needed
//       }

//       try {
//         const response = await propertyService.fetchProperties();
//         const data = response.data;
//         //console.log(data)
//         let propertiesDetails = [];
//         Object.keys(data).forEach((item) => {
//           propertiesDetails.push({ id: item, name: data[item].name });
//         });

//         setProperties(propertiesDetails);
//       } catch (error) {
//         console.error("Error fetching properties:", error);
//         // Handle error if needed
//       }

//       try {
//         const response = await teamService.fetchTeams();
//         const data = response.data;
//         setTeams(data);
//       } catch (error) {
//         console.error("Error fetching teams:", error);
//         // Handle error if needed
//       }
//     })();
//   }, []);

//   const status = [
//     "Fresh",
//         "Follow-up",
//         "Dealing",
//         "Registered Client",
//     "Deal Lost",
//     "Unanswered",
//     "Not Interested",
//     "Retry Suitable",
//   ];

//   const handleTeamChange = async (e) => {
//     setSelectedTeam(e);
//     setErrors((prevErrors) => ({ ...prevErrors, teams: "" }));

//     try {
//       const response = await axios.get(
//         `https://client-glfunnel-service-144135692330.asia-south1.run.app/api/v1/user/role/FIELD WORKER/${e}`
//       );
//       const data = response.data;
//       setFieldWorkers(data);
//     } catch (error) {
//       if (error.response && error.response.status === 204) {
//         console.log(`field:${error.response.status}`);
//         // setFieldWorkers("There is no field worker")
//         setFieldWorkerError(true);
//       }
//       console.error("Error fetching teams:", error);
//       // Handle error if needed
//     }
//   };

//   const handleLeadSourceChange = (e) => {
//     console.log(e)
//     setSelectedLeadSource(e);
//     setSelectedLeadSourceId(e.value)
//     setErrors((prevErrors) => ({ ...prevErrors, leadSources: "" }));
//   };

//   const handlePropertyChange = (e) => {
//     setSelectedProperty(e);
//   };

//   const handleStatusChange = (e) => {
//     setSelectedStatus(leadStatusMap[e]);
//     setErrors((prevErrors) => ({ ...prevErrors, status: "" }));
//   };

//   const handleFieldWorkerChange = (e) => {
//     setSelectedFieldWorker(e);
//   };

//   const handleDownloadTemplate = () => {
//     const link = document.createElement("a");
//     link.href = "/sample-template for bulk upload.xlsx";
//     link.setAttribute("download", "sample-template for bulk upload.xlsx");
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   };
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const handleOpenModal = () => {
//     setIsModalOpen(true);
//   };

//   // Function to close the image modal
//   const handleCloseModal = () => {
//     setIsModalOpen(false);
//   };

//   const handleUpload = () => {
//     // if (!validateForm()) return;
// console.log(`here file ${selectedFile.name}`)
//     let tags = [];
//     interestTags.forEach((item) => {
//       tags.push(item.value);
//     });

//     const formData = new FormData();
//     // formData.append("file", selectedFile); // Assuming fileInput is your input element
//     if (selectedFile) {
//       formData.append("file", selectedFile);
//     } else {
//       console.error("No file selected.");
//       return;
//     }

//     formData.set("interestTags",JSON.stringify(tags))
//     formData.append("leadSource", selectedLeadSourceId);
//     formData.append("assignedTeam", selectedTeam);
//     formData.append("createdBy", userObj.user.uid);
//     formData.append("fieldWorker",selectedFieldWorker );
//     //formData.append("interestTags",  tags);
//     formData.append("interestedProperty", selectedProperty);
//     formData.append("modifiedBy", userObj.user.uid);
//     formData.append("status",selectedStatus)

//     // let obj = {
//     //   assignedTeam: selectedTeam,
//     //   createdBy: userObj.user.uid,
//     //   fieldWorker: selectedFieldWorker,
//     //   interestTags: tags,
//     //   interestedProperty: selectedProperty,
//     //   leadSource: selectedLeadSource,
//     //   modifiedBy: userObj.user.uid,
//     //   // leads: inputJson,
//     //   status: selectedStatus,
//     // };
//     setLoading(true);

//     LeadUploadService.createBulkUpload(formData)

//       .then(async (response) => {
//         console.log("Property Added Successfully:", response.data);

//         await new Promise((resolve) => setTimeout(resolve, 1000));
//         if(userRole === "Admin"){
//           navigate("/admin/lead-upload", {
//             state: {
//               message:
//                 "Lead Uploaded is in progress will notify you in mail if their is any error",
//             },
//           });
//         }else if(userRole === "CMO"){
//           navigate("/cmo/lead-upload", {
//             state: {
//               message:
//                 "Lead Uploaded is in progress will notify you in mail if their is any error",
//             },
//           });
//         }

//       })
//       .catch((error) => {
//         console.error("There was an error adding the property:", error);
//       })
//       .finally(() => {
//         setLoading(false);
//       });
//   };
//   return (
//     <>
//      {userRole === "Lead Uploader"? <AppBar />: <AdminAppBar />}

//       <ToastContainer />

//       <div className=" bg-appGrayBackground px-6 flex flex-col gap-5 pb-5 mt-20 pt-4 pt-1">
//         <div className="flex justify-between gap-5 ">
//           <div className="flex gap-6">
//           <svg
//             onClick={handleBack}
//             className="cursor-pointer "
//             width="20"
//             height="34"
//             viewBox="0 0 22 38"
//             fill="none"
//             xmlns="http://www.w3.org/2000/svg"
//           >
//             <path
//               d="M1.23223 17.2322C0.255922 18.2085 0.255922 19.7915 1.23223 20.7678L17.1421 36.6777C18.1184 37.654 19.7014 37.654 20.6777 36.6777C21.654 35.7014 21.654 34.1184 20.6777 33.1421L6.53553 19L20.6777 4.85786C21.654 3.88155 21.654 2.29864 20.6777 1.32233C19.7014 0.34602 18.1184 0.34602 17.1421 1.32233L1.23223 17.2322ZM5 16.5L3 16.5L3 21.5L5 21.5L5 16.5Z"
//               fill="#399E79"
//             />
//           </svg>
//           <div className="font-semibold md:mx-0  lg:mx-0 md:text-2xl lg:text-4xl">
//               Bulk Upload
//             </div>
//           </div>

//           <div className="">

//             <button
//               onClick={handleUpload}
//               className="bg-customGreen text-white md:w-28  md:h-9 lg:w-48 lg:h-11 rounded-md md:text-xl
//           lg:text-2xl font-medium"
//               disabled={loading}
//             >
//               {" "}
//               {loading ? (
//                 <div className="flex justify-center items-center h-full">
//                   <div className="animate-spin rounded-full h-8 w-8 border-t-4 border-b-4 border-white"></div>
//                 </div>
//               ) : (
//                 "Upload"
//               )}
//             </button>
//           </div>
//       </div>

//           <form className="bg-white shadow-md rounded mx-12 p-5">
//             <div className="mb-8 flex items-center">
//               <label
//                 className="w-1/4 text-black text-2xl xl:text-xl  font-bold"
//                 htmlFor="lead-source"
//               >
//                 Lead Source
//               </label>
//               <div className="flex w-3/4">
//                 <Select
//                   options={leadSources.map((source) => ({
//                     value: source.id,
//                     label: source.name,
//                   }))}
//                   onChange={handleLeadSourceChange}
//                   value={selectedLeadSource}
//                   placeholder="Select Lead Source"
//                   isClearable
//                   isSearchable
//                   className="w-full focus:outline-none focus:shadow-outline"
//                 />
//               </div>
//             </div>
//             <div className="mb-8 flex items-center">
//               <label
//                 className="w-1/4 text-black text-2xl xl:text-xl  font-bold"
//                 htmlFor="interest-tag"
//               >
//                 Interest Tag
//               </label>
//               <div className="flex w-3/4  ">
//                 <Select
//                   className={`w-full py-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
//                     errors.interestTags && "border-red-500"
//                   }`}
//                   // className="w-full py-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
//                   value={interestTags}
//                   onChange={handleChange}
//                   options={options}
//                   isMulti
//                   //   menuPlacement="top"
//                   onMenuOpen={() => setMenuOpen(true)}
//                   onMenuClose={() => setMenuOpen(false)}
//                   styles={{
//                     control: (provided) => ({
//                       ...provided,
//                       minHeight: "100px",
//                     }),
//                     multiValue: (provided) => ({
//                       ...provided,
//                       backgroundColor: "#339E79", // Change background color of the chip
//                       borderRadius: "4px",
//                       padding: "2px 4px",
//                       color: "white", // Change text color of the chip
//                     }),
//                     multiValueLabel: (provided) => ({
//                       ...provided,
//                       color: "white",
//                       // Change text color of the label inside the chip
//                     }),
//                   }}
//                   placeholder={errors.interestTags || "Type to search eg :"}
//                 />
//               </div>
//             </div>
//             <div className=" flex w-full justify-between">

//             <div className="mb-8 flex justify-between w-full gap-5">
//               <label
//                 className="w-1/4 text-black text-2xl xl:text-xl  font-bold"
//                 htmlFor="file-upload"
//               >
//                 Attach File
//               </label>
//               <label className="w-full ml-24 ">
//                 <div className="relative border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline cursor-pointer">
//                   <span className="absolute inset-y-0 right-3 flex items-center pl-3">
//                     <svg
//                       className=" md:w-6"
//                       width="30"
//                       height="30"
//                       viewBox="0 0 135 135"
//                       fill="none"
//                       xmlns="http://www.w3.org/2000/svg"
//                     >
//                       <path
//                         d="M0 0H134.449V134.449H0V0Z"
//                         fill="white"
//                         fill-opacity="0.01"
//                       />
//                       <path
//                         d="M67.2231 123.245H22.4067V11.2036H112.04V67.2242"
//                         stroke="#399E79"
//                         stroke-width="7.31632"
//                         stroke-linecap="round"
//                         stroke-linejoin="round"
//                       />
//                       <path
//                         d="M99.4365 123.245V86.8313"
//                         stroke="#399E79"
//                         stroke-width="7.31632"
//                         stroke-linecap="round"
//                         stroke-linejoin="round"
//                       />
//                       <path
//                         d="M86.8325 96.6349L91.0341 92.4334L99.4371 84.0303L107.84 92.4334L112.042 96.6349"
//                         stroke="#399E79"
//                         stroke-width="7.31632"
//                         stroke-linecap="round"
//                         stroke-linejoin="round"
//                       />
//                       <path
//                         d="M44.8152 44.8159H89.6316"
//                         stroke="#399E79"
//                         stroke-width="7.31632"
//                         stroke-linecap="round"
//                       />
//                       <path
//                         d="M44.8152 67.2241H67.2234"
//                         stroke="#399E79"
//                         stroke-width="7.31632"
//                         stroke-linecap="round"
//                       />
//                     </svg>
//                   </span>
//                   <span className="pl-0 pr-3 py-1">
//                     {selectedFile
//                       ? selectedFile.name
//                       : "Click here to select a file from your computer"}
//                   </span>
//                   <input
//                     id="file-upload"
//                     className="absolute inset-0 w-full  opacity-0 cursor-pointer"
//                     type="file"
//                     // onChange={handleFileChange}
//                     onChange={(e)=>setSelectedFile(e.target.files[0])}
//                   />
//                 </div>

//               </label>

//               <div className="flex gap-5 ">
//                   <div
//                     className="flex flex-col items-center cursor-pointer"
//                     onClick={handleOpenModal}
//                   >
//                     <img src={icon.infoIcon} alt="" className="w-5" />
//                     <div>Instruction</div>
//                   </div>

//                   <div
//                     className="flex flex-col items-center cursor-pointer"
//                     onClick={handleDownloadTemplate}
//                   >
//                     <img src={icon.downloadIcon} alt="" className="w-5" />
//                     <div>Template</div>
//                   </div>
//                 </div>
//             </div>

//             </div>

//             {/* <div className="mb-8 flex items-center gap-5">
//               <label
//                 className="w-1/3 text-black text-2xl xl:text-xl font-bold"
//                 htmlFor="phone-code"
//               >
//                 Budget
//               </label>

//               <input
//                 className="shadow appearance-none border rounded w-1/3 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
//                 id=""
//                 type=""
//                 placeholder=""
//                 onChange={handleBudgetChange}
//               />

//               <label
//                 className="w-1/3 pl-16 text-black text-2xl xl:text-xl font-bold"
//                 htmlFor=""
//               >
//                 Interested Property
//               </label>

//               <div className="flex w-1/3 relative">
//                 <select
//                   className="appearance-none w-full shadow border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
//                   id="lead-source"
//                   name="lead-source"
//                   onChange={(e) => handlePropertyChange(e.target.value)}
//                 >
//                   <option value="">Select Interested Property</option>

//                   {properties.map((item, index) => {
//                     return (
//                       <option key={index} value={item.id}>
//                         {item.name}
//                       </option>
//                     );
//                   })}
//                 </select>
//                 <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
//                   <svg
//                     width="18"
//                     height="12"
//                     viewBox="0 0 24 14"
//                     fill="none"
//                     xmlns="http://www.w3.org/2000/svg"
//                   >
//                     <path
//                       d="M10.9393 13.0607C11.5251 13.6464 12.4749 13.6464 13.0607 13.0607L22.6066 3.51472C23.1924 2.92893 23.1924 1.97919 22.6066 1.3934C22.0208 0.807611 21.0711 0.807611 20.4853 1.3934L12 9.87868L3.51472 1.3934C2.92893 0.807611 1.97919 0.807611 1.3934 1.3934C0.807611 1.97919 0.807611 2.92893 1.3934 3.51472L10.9393 13.0607ZM10.5 10V12H13.5V10H10.5Z"
//                       fill="#399E79"
//                     />
//                   </svg>
//                 </div>
//               </div>
//             </div> */}

//             <div className="mb-8 flex items-center">
//               <label
//                 className="w-1/4 text-black text-2xl xl:text-xl font-bold"
//                 htmlFor="lead-source"
//               >
//                 Assign to team
//               </label>
//               <div className="flex w-3/4 relative">
//                 <select
//                   className={`appearance-none w-full shadow border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
//                     errors.teams && "border-red-500"
//                   }`}
//                   // className="appearance-none w-full shadow border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
//                   id="lead-source"
//                   name="lead-source"
//                   onChange={(e) => handleTeamChange(e.target.value)}
//                 >
//                   <option value="">Select Team</option>

//                   {teams.map((item, index) => {
//                     return (
//                       <option key={index} value={item.teamId}>
//                         {item.name}
//                       </option>
//                     );
//                   })}
//                 </select>
//                 <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
//                   <svg
//                     width="18"
//                     height="12"
//                     viewBox="0 0 24 14"
//                     fill="none"
//                     xmlns="http://www.w3.org/2000/svg"
//                   >
//                     <path
//                       d="M10.9393 13.0607C11.5251 13.6464 12.4749 13.6464 13.0607 13.0607L22.6066 3.51472C23.1924 2.92893 23.1924 1.97919 22.6066 1.3934C22.0208 0.807611 21.0711 0.807611 20.4853 1.3934L12 9.87868L3.51472 1.3934C2.92893 0.807611 1.97919 0.807611 1.3934 1.3934C0.807611 1.97919 0.807611 2.92893 1.3934 3.51472L10.9393 13.0607ZM10.5 10V12H13.5V10H10.5Z"
//                       fill="#399E79"
//                     />
//                   </svg>
//                 </div>
//               </div>
//             </div>

//             <div className="mb-8 flex items-center">
//               <label
//                 className="w-1/4 text-black text-2xl xl:text-xl font-bold"
//                 htmlFor="lead-source"
//               >
//                 Status
//               </label>
//               <div className="flex w-3/4 relative">
//                 <select
//                   className={`appearance-none w-full shadow border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
//                     errors.status && "border-red-500"
//                   }`}
//                   // className="appearance-none w-full shadow border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
//                   id="lead-source"
//                   name="lead-source"
//                   onChange={(e) => handleStatusChange(e.target.value)}
//                 >
//                   <option value="">Select Status</option>

//                   {status.map((item, index) => {
//                     return (
//                       <option key={index} value={item}>
//                         {item}
//                       </option>
//                     );
//                   })}
//                 </select>
//                 <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
//                   <svg
//                     width="18"
//                     height="12"
//                     viewBox="0 0 24 14"
//                     fill="none"
//                     xmlns="http://www.w3.org/2000/svg"
//                   >
//                     <path
//                       d="M10.9393 13.0607C11.5251 13.6464 12.4749 13.6464 13.0607 13.0607L22.6066 3.51472C23.1924 2.92893 23.1924 1.97919 22.6066 1.3934C22.0208 0.807611 21.0711 0.807611 20.4853 1.3934L12 9.87868L3.51472 1.3934C2.92893 0.807611 1.97919 0.807611 1.3934 1.3934C0.807611 1.97919 0.807611 2.92893 1.3934 3.51472L10.9393 13.0607ZM10.5 10V12H13.5V10H10.5Z"
//                       fill="#399E79"
//                     />
//                   </svg>
//                 </div>
//               </div>
//             </div>

//             <div className="mb-8 flex items-center">
//               <label
//                 className="w-1/4 text-black text-2xl xl:text-xl font-bold"
//                 htmlFor="lead-source"
//               >
//                 Field Worker
//               </label>
//               <div className="flex w-3/4 relative">
//                 <select
//                   className="appearance-none w-full shadow border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
//                   id="lead-source"
//                   name="lead-source"
//                   onChange={(e) => handleFieldWorkerChange(e.target.value)}
//                 >
//                   {/* {fieldWorkerError ?(
//                   <option value="">Select Field worker</option>

//                   ):(
//                   <option value="">Select Field worker</option>

//                   {Array.isArray(fieldWorkers) && fieldWorkers.map((item, index) => {
//                     return (
//                       <option key={index} value={item.uid}>
//                         {item.name}
//                       </option>
//                     )

//                   })})} */}
//                   {fieldWorkerError ? (
//                     <option value="">No more field workers</option>
//                   ) : (
//                     <>
//                       <option value="">Select Field worker</option>
//                       {Array.isArray(fieldWorkers) &&
//                         fieldWorkers.map((item, index) => {
//                           return (
//                             <option key={index} value={item.uid}>
//                               {item.name}
//                             </option>
//                           );
//                         })}
//                     </>
//                   )}
//                 </select>
//                 <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
//                   <svg
//                     width="18"
//                     height="12"
//                     viewBox="0 0 24 14"
//                     fill="none"
//                     xmlns="http://www.w3.org/2000/svg"
//                   >
//                     <path
//                       d="M10.9393 13.0607C11.5251 13.6464 12.4749 13.6464 13.0607 13.0607L22.6066 3.51472C23.1924 2.92893 23.1924 1.97919 22.6066 1.3934C22.0208 0.807611 21.0711 0.807611 20.4853 1.3934L12 9.87868L3.51472 1.3934C2.92893 0.807611 1.97919 0.807611 1.3934 1.3934C0.807611 1.97919 0.807611 2.92893 1.3934 3.51472L10.9393 13.0607ZM10.5 10V12H13.5V10H10.5Z"
//                       fill="#399E79"
//                     />
//                   </svg>
//                 </div>
//               </div>
//             </div>
//             {isModalOpen && (
//               <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
//                 <div className="bg-white rounded-lg p-4 md:w-1/2 w-full relative">
//                   <button
//                     onClick={handleCloseModal}
//                     className="absolute top-2 right-4 text-black font-bold text-xl"
//                   >
//                     &times;
//                   </button>
//                   <h2 className="text-2xl font-semibold mb-4">
//                     Excel Template Reference
//                   </h2>
//                   <img
//                     src={icon.excelImage}
//                     alt="Excel Template Reference"
//                     className="w-full h-auto"
//                   />
//                 </div>
//               </div>
//             )}
//           </form>
//         </div>

//     </>
//   );
// };

// export default AdminBulkUpload;
